module.exports = __webpack_public_path__ + "img/lib_region_flag_tv.20dc533f.png";